module.exports = "/_next/static/images/45b9e157648011bd2ac9a7ca886a3aad-slide-2.png";